export const riderValidHeaders = [
  'First Name*',
  'Last Name*',
  'Date of birth*',
  'Gender*',
  'Category*',
  'Phone number',
  'Email',
  'ID number',
  'Code word*',
  'Rider notes',
  'Can sit up front',
  'Needs a booster',
  'Caregiver First Name*',
  'Caregiver Last Name*',
  'Relationship',
  'Caregiver phone*',
  'Caregiver email',
  'Contact 2 First Name',
  'Contact 2 Last Name',
  'Contact 2 Relationship',
  'Contact 2 phone',
  'Contact 2 Role',
  'Rider Services',
  'Location Name 1',
  'Location Address 1',
  'Location Type 1',
  'Must be met Protocol 1',
  'Location Name 2',
  'Location Address 2',
  'Location Type 2',
  'Must be met Protocol 2',
  'Location Name 3',
  'Location Address 3',
  'Location Type 3',
  'Must be met Protocol 3',
];
